var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container member-day-config" },
    [
      _c(
        "el-tabs",
        {
          attrs: { "tab-position": "left", type: "border-card" },
          model: {
            value: _vm.activeModule,
            callback: function ($$v) {
              _vm.activeModule = $$v
            },
            expression: "activeModule",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "活动设置", name: "setting" } },
            [
              _c(
                "el-form",
                {
                  ref: "mainForm",
                  staticClass: "setting-form",
                  attrs: {
                    model: _vm.form,
                    rules: _vm.mainRules,
                    "label-width": "100px",
                  },
                },
                [
                  _c("div", { staticClass: "setting-columns" }, [
                    _c(
                      "div",
                      { staticClass: "setting-col" },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "大标题", prop: "title" } },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: "请输入大标题",
                                maxlength: "64",
                                "show-word-limit": "",
                              },
                              model: {
                                value: _vm.form.title,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "title", $$v)
                                },
                                expression: "form.title",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { label: "小标题" } },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: "请输入小标题",
                                maxlength: "128",
                                "show-word-limit": "",
                              },
                              model: {
                                value: _vm.form.subTitle,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "subTitle", $$v)
                                },
                                expression: "form.subTitle",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { label: "备注" } },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: "请输入备注",
                                maxlength: "255",
                              },
                              model: {
                                value: _vm.form.remark,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "remark", $$v)
                                },
                                expression: "form.remark",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { label: "活动时间" } },
                          [
                            _c("el-date-picker", {
                              staticStyle: {
                                width: "100%",
                                "max-width": "400px",
                              },
                              attrs: {
                                type: "datetimerange",
                                "range-separator": "至",
                                "start-placeholder": "开始时间",
                                "end-placeholder": "结束时间",
                                "value-format": "yyyy-MM-dd HH:mm:ss",
                              },
                              model: {
                                value: _vm.timeRange,
                                callback: function ($$v) {
                                  _vm.timeRange = $$v
                                },
                                expression: "timeRange",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { label: "有效时间" } },
                          [
                            _c("el-time-picker", {
                              staticStyle: { width: "130px" },
                              attrs: {
                                "value-format": "HH:mm",
                                format: "HH:mm",
                                placeholder: "开始时间",
                              },
                              model: {
                                value: _vm.form.dayStartTime,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "dayStartTime", $$v)
                                },
                                expression: "form.dayStartTime",
                              },
                            }),
                            _vm._v(" "),
                            _c("span", { staticStyle: { margin: "0 6px" } }, [
                              _vm._v("至"),
                            ]),
                            _vm._v(" "),
                            _c("el-time-picker", {
                              staticStyle: { width: "130px" },
                              attrs: {
                                "value-format": "HH:mm",
                                format: "HH:mm",
                                placeholder: "结束时间",
                              },
                              model: {
                                value: _vm.form.dayEndTime,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "dayEndTime", $$v)
                                },
                                expression: "form.dayEndTime",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { label: "活动规则" } },
                          [
                            _c("el-input", {
                              attrs: {
                                type: "textarea",
                                rows: 8,
                                placeholder: "请输入活动规则",
                              },
                              model: {
                                value: _vm.form.rule,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "rule", $$v)
                                },
                                expression: "form.rule",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-divider",
                          { attrs: { "content-position": "left" } },
                          [_vm._v("\n              权益模块\n            ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { label: "专区顺序" } },
                          [
                            _c(
                              "draggable",
                              {
                                staticClass: "zone-sort-list",
                                attrs: {
                                  animation: 150,
                                  "ghost-class": "zone-sort-ghost",
                                  filter: ".zone-disabled",
                                },
                                model: {
                                  value: _vm.zoneOrder,
                                  callback: function ($$v) {
                                    _vm.zoneOrder = $$v
                                  },
                                  expression: "zoneOrder",
                                },
                              },
                              _vm._l(_vm.zoneOrder, function (type, index) {
                                return _c(
                                  "div",
                                  {
                                    key: type,
                                    staticClass: "zone-sort-item",
                                    class: {
                                      "zone-disabled":
                                        _vm.getModule(type).showStatus !== 1,
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "el-icon-rank zone-drag-icon",
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "zone-sort-name" },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(index + 1) +
                                            ". " +
                                            _vm._s(
                                              _vm.getModuleDef(type).label
                                            ) +
                                            "\n                  "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("el-switch", {
                                      attrs: {
                                        "active-value": 1,
                                        "inactive-value": 0,
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.handleZoneStatusChange(
                                            type
                                          )
                                        },
                                      },
                                      model: {
                                        value: _vm.getModule(type).showStatus,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.getModule(type),
                                            "showStatus",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "getModule(type).showStatus",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              }),
                              0
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "zone-sort-tip" }, [
                              _vm._v(
                                "\n                拖动行可调整专区在活动页的展示顺序；关闭的专区自动排在下方，开启后回到上方\n              "
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "setting-col" },
                      [
                        _c(
                          "el-divider",
                          { attrs: { "content-position": "left" } },
                          [_vm._v("\n              背景与预热\n            ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { label: "背景图1" } },
                          [
                            _c("image-upload", {
                              model: {
                                value: _vm.form.bannerUrl,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "bannerUrl", $$v)
                                },
                                expression: "form.bannerUrl",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { label: "背景图2" } },
                          [
                            _c("image-upload", {
                              model: {
                                value: _vm.form.bannerUrl2,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "bannerUrl2", $$v)
                                },
                                expression: "form.bannerUrl2",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { label: "预热图" } },
                          [
                            _c("image-upload", {
                              model: {
                                value: _vm.form.preheatImgUrl,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "preheatImgUrl", $$v)
                                },
                                expression: "form.preheatImgUrl",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { label: "预热时间" } },
                          [
                            _c("el-date-picker", {
                              staticStyle: {
                                width: "100%",
                                "max-width": "400px",
                              },
                              attrs: {
                                type: "datetimerange",
                                "range-separator": "至",
                                "start-placeholder": "预热开始时间",
                                "end-placeholder": "预热结束时间",
                                "value-format": "yyyy-MM-dd HH:mm:ss",
                              },
                              model: {
                                value: _vm.preheatRange,
                                callback: function ($$v) {
                                  _vm.preheatRange = $$v
                                },
                                expression: "preheatRange",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { label: "星期" } },
                          [
                            _c(
                              "el-checkbox",
                              {
                                attrs: {
                                  indeterminate: _vm.isWeekIndeterminate,
                                  checked: _vm.weeksArr.length === 7,
                                },
                                on: { change: _vm.handleCheckAllWeek },
                              },
                              [_vm._v("\n                全选\n              ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-checkbox-group",
                              {
                                model: {
                                  value: _vm.weeksArr,
                                  callback: function ($$v) {
                                    _vm.weeksArr = $$v
                                  },
                                  expression: "weeksArr",
                                },
                              },
                              _vm._l(_vm.weekOptions, function (w) {
                                return _c(
                                  "el-checkbox",
                                  { key: w.value, attrs: { label: w.value } },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(w.label) +
                                        "\n                "
                                    ),
                                  ]
                                )
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-divider",
                          { attrs: { "content-position": "left" } },
                          [_vm._v("\n              分享设置\n            ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { label: "分享标题" } },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: "请输入分享标题",
                                maxlength: "128",
                              },
                              model: {
                                value: _vm.form.shareTitle,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "shareTitle", $$v)
                                },
                                expression: "form.shareTitle",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { label: "分享图" } },
                          [
                            _c("image-upload", {
                              model: {
                                value: _vm.form.shareImgUrl,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "shareImgUrl", $$v)
                                },
                                expression: "form.shareImgUrl",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { label: "是否启用" } },
                          [
                            _c("el-switch", {
                              attrs: { "active-value": 1, "inactive-value": 0 },
                              model: {
                                value: _vm.form.enabled,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "enabled", $$v)
                                },
                                expression: "form.enabled",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.visibleModuleDefs, function (m) {
            return _c(
              "el-tab-pane",
              {
                key: m.type,
                attrs: { label: m.label, name: "module_" + m.type },
              },
              [
                _c(
                  "el-form",
                  {
                    style:
                      m.type === 1 ||
                      m.type === 2 ||
                      m.type === 3 ||
                      m.type === 4
                        ? "max-width: none;"
                        : "max-width: 900px;",
                    attrs: { "label-width": "100px" },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "专区标题" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "400px" },
                          attrs: {
                            placeholder: "请输入" + m.label + "标题",
                            maxlength: "64",
                          },
                          model: {
                            value: _vm.getModule(m.type).title,
                            callback: function ($$v) {
                              _vm.$set(_vm.getModule(m.type), "title", $$v)
                            },
                            expression: "getModule(m.type).title",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    m.type === 5
                      ? [
                          _c(
                            "el-form-item",
                            { attrs: { label: "积分抽奖图" } },
                            [
                              _c("image-upload", {
                                model: {
                                  value: _vm.getModule(5).imgUrl,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.getModule(5), "imgUrl", $$v)
                                  },
                                  expression: "getModule(5).imgUrl",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "抽奖活动" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "400px" },
                                  attrs: {
                                    filterable: "",
                                    clearable: "",
                                    placeholder: "请选择抽奖活动",
                                  },
                                  model: {
                                    value: _vm.getModule(5).refId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.getModule(5), "refId", $$v)
                                    },
                                    expression: "getModule(5).refId",
                                  },
                                },
                                _vm._l(_vm.lotteryOptions, function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: {
                                      label: item.id + " - " + item.label,
                                      value: item.id,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "跳转类型" } },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  on: {
                                    change: _vm.handleLotteryJumpTypeChange,
                                  },
                                  model: {
                                    value: _vm.lotteryJumpType,
                                    callback: function ($$v) {
                                      _vm.lotteryJumpType = $$v
                                    },
                                    expression: "lotteryJumpType",
                                  },
                                },
                                [
                                  _c(
                                    "el-radio",
                                    { attrs: { label: "community" } },
                                    [
                                      _vm._v(
                                        "\n                社区\n              "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-radio",
                                    { attrs: { label: "dining" } },
                                    [
                                      _vm._v(
                                        "\n                点餐\n              "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "跳转页面" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "400px" },
                                  attrs: {
                                    filterable: "",
                                    clearable: "",
                                    placeholder: "请选择跳转页面",
                                  },
                                  model: {
                                    value: _vm.getModule(5).pageId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.getModule(5), "pageId", $$v)
                                    },
                                    expression: "getModule(5).pageId",
                                  },
                                },
                                _vm._l(_vm.lotteryPageOptions, function (p) {
                                  return _c("el-option", {
                                    key: p.id,
                                    attrs: { label: p.label, value: p.id },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      : m.type === 4
                      ? [
                          _c(
                            "el-divider",
                            { attrs: { "content-position": "left" } },
                            [
                              _vm._v(
                                "\n            会员日发券列表（" +
                                  _vm._s(_vm.getModule(4).items.length) +
                                  "个）\n          "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "coupon-pkg-list" },
                            _vm._l(_vm.getModule(4).items, function (pkg, idx) {
                              return _c(
                                "div",
                                { key: "pkg" + idx, staticClass: "coupon-pkg" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "coupon-pkg-head" },
                                    [
                                      _c("span", [
                                        _vm._v("会员日发券 " + _vm._s(idx + 1)),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "el-button",
                                        {
                                          staticStyle: { color: "#F56C6C" },
                                          attrs: {
                                            type: "text",
                                            size: "small",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.removeItem(4, idx)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  删除\n                "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "列表图",
                                        "label-width": "90px",
                                      },
                                    },
                                    [
                                      _c("image-upload", {
                                        model: {
                                          value: pkg.imgUrl,
                                          callback: function ($$v) {
                                            _vm.$set(pkg, "imgUrl", $$v)
                                          },
                                          expression: "pkg.imgUrl",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "优惠券发放",
                                        "label-width": "90px",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            filterable: "",
                                            clearable: "",
                                            placeholder: "请选择优惠券发放",
                                          },
                                          model: {
                                            value: pkg.refId,
                                            callback: function ($$v) {
                                              _vm.$set(pkg, "refId", $$v)
                                            },
                                            expression: "pkg.refId",
                                          },
                                        },
                                        _vm._l(
                                          _vm.bonusSendOptions,
                                          function (c) {
                                            return _c("el-option", {
                                              key: c.id,
                                              attrs: {
                                                label: c.id + " - " + c.label,
                                                value: c.id,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "名称",
                                        "label-width": "90px",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          placeholder: "请输入名称",
                                          maxlength: "64",
                                        },
                                        model: {
                                          value: pkg.tips,
                                          callback: function ($$v) {
                                            _vm.$set(pkg, "tips", $$v)
                                          },
                                          expression: "pkg.tips",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "描述",
                                        "label-width": "90px",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          placeholder: "请输入描述",
                                          maxlength: "255",
                                        },
                                        model: {
                                          value: pkg.description,
                                          callback: function ($$v) {
                                            _vm.$set(pkg, "description", $$v)
                                          },
                                          expression: "pkg.description",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "到期时间",
                                        "label-width": "90px",
                                      },
                                    },
                                    [
                                      _c("el-date-picker", {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          type: "datetime",
                                          "value-format": "yyyy-MM-dd HH:mm:ss",
                                          placeholder: "请选择到期时间",
                                        },
                                        model: {
                                          value: pkg.endTime,
                                          callback: function ($$v) {
                                            _vm.$set(pkg, "endTime", $$v)
                                          },
                                          expression: "pkg.endTime",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            }),
                            0
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                plain: "",
                                icon: "el-icon-plus",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.addItem(4)
                                },
                              },
                            },
                            [_vm._v("\n            添加会员日发券\n          ")]
                          ),
                        ]
                      : m.type === 1 || m.type === 2 || m.type === 3
                      ? [
                          _c(
                            "el-divider",
                            { attrs: { "content-position": "left" } },
                            [
                              _vm._v(
                                "\n            会员日" +
                                  _vm._s(_vm.zoneShortName(m.type)) +
                                  "列表（" +
                                  _vm._s(_vm.getModule(m.type).items.length) +
                                  "个）\n          "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "coupon-pkg-list" },
                            _vm._l(
                              _vm.getModule(m.type).items,
                              function (pkg, idx) {
                                return _c(
                                  "div",
                                  {
                                    key: "zone" + m.type + "_" + idx,
                                    staticClass: "coupon-pkg",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "coupon-pkg-head" },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            "会员日" +
                                              _vm._s(
                                                _vm.zoneShortName(m.type)
                                              ) +
                                              " " +
                                              _vm._s(idx + 1)
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "el-button",
                                          {
                                            staticStyle: { color: "#F56C6C" },
                                            attrs: {
                                              type: "text",
                                              size: "small",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.removeItem(
                                                  m.type,
                                                  idx
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  删除\n                "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: m.itemLabel,
                                          "label-width": "90px",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              filterable: "",
                                              clearable: "",
                                              placeholder:
                                                "请选择" + m.itemLabel,
                                            },
                                            model: {
                                              value: pkg.refId,
                                              callback: function ($$v) {
                                                _vm.$set(pkg, "refId", $$v)
                                              },
                                              expression: "pkg.refId",
                                            },
                                          },
                                          _vm._l(
                                            _vm.getZoneItemOptions(m.type),
                                            function (c) {
                                              return _c("el-option", {
                                                key: c.id,
                                                attrs: {
                                                  label: c.id + " - " + c.label,
                                                  value: c.id,
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label:
                                            _vm.zoneTipsName(m.type) + "提示",
                                          "label-width": "90px",
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            placeholder:
                                              "请输入" +
                                              _vm.zoneTipsName(m.type) +
                                              "提示",
                                            maxlength: "64",
                                          },
                                          model: {
                                            value: pkg.tips,
                                            callback: function ($$v) {
                                              _vm.$set(pkg, "tips", $$v)
                                            },
                                            expression: "pkg.tips",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "排序",
                                          "label-width": "90px",
                                        },
                                      },
                                      [
                                        _c("el-input-number", {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            min: 0,
                                            "controls-position": "right",
                                          },
                                          model: {
                                            value: pkg.sort,
                                            callback: function ($$v) {
                                              _vm.$set(pkg, "sort", $$v)
                                            },
                                            expression: "pkg.sort",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "sk-sort-tip" },
                                          [
                                            _vm._v(
                                              "\n                  排序从小到大展示，新增时默认递增\n                "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              }
                            ),
                            0
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                plain: "",
                                icon: "el-icon-plus",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.addItem(m.type)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            添加会员日" +
                                  _vm._s(_vm.zoneShortName(m.type)) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ]
                      : [
                          _c(
                            "el-form-item",
                            { attrs: { label: "专区图片" } },
                            [
                              _c("image-upload", {
                                model: {
                                  value: _vm.getModule(6).imgUrl,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.getModule(6), "imgUrl", $$v)
                                  },
                                  expression: "getModule(6).imgUrl",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "跳转类型" } },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  on: { change: _vm.handlePdJumpTypeChange },
                                  model: {
                                    value: _vm.pdJumpType,
                                    callback: function ($$v) {
                                      _vm.pdJumpType = $$v
                                    },
                                    expression: "pdJumpType",
                                  },
                                },
                                [
                                  _c(
                                    "el-radio",
                                    { attrs: { label: "community" } },
                                    [
                                      _vm._v(
                                        "\n                社区\n              "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-radio",
                                    { attrs: { label: "dining" } },
                                    [
                                      _vm._v(
                                        "\n                点餐\n              "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "跳转页面" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "400px" },
                                  attrs: {
                                    filterable: "",
                                    clearable: "",
                                    placeholder: "请选择跳转页面",
                                  },
                                  model: {
                                    value: _vm.getModule(6).refId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.getModule(6), "refId", $$v)
                                    },
                                    expression: "getModule(6).refId",
                                  },
                                },
                                _vm._l(_vm.pdPageOptions, function (p) {
                                  return _c("el-option", {
                                    key: p.id,
                                    attrs: { label: p.label, value: p.id },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                  ],
                  2
                ),
              ],
              1
            )
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "footer-bar" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.saving },
              on: { click: _vm.handleSave },
            },
            [_vm._v("\n      保 存\n    ")]
          ),
          _vm._v(" "),
          _c("el-button", { on: { click: _vm.handleCancel } }, [
            _vm._v("\n      返 回\n    "),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }